<template>
  <!-- How to cancel where Soldera can't cancel directly. Shared by bulk-buy and the cancel tab's review
       step so both offer the same choice with the same copy (DEV-626 change 8). -->
  <div
    class="d-flex flex-column flex-sm-row gap-2"
    role="group"
    :aria-label="t('bulk_buy.cancellation_mode_selection_aria')"
  >
    <input
      :id="agentId"
      v-model="mode"
      type="radio"
      class="btn-check"
      :name="groupName"
      :value="CancellationMode.COMPLIANT_AGENT"
      autocomplete="off"
    />
    <label class="btn btn-outline-primary" :for="agentId">
      <FontAwesomeIcon icon="user" class="me-1" />
      {{ t("bulk_buy.cancellation_option_agent") }}
    </label>

    <input
      :id="anyAibId"
      v-model="mode"
      type="radio"
      class="btn-check"
      :name="groupName"
      :value="CancellationMode.ANY_AIB_REGISTRY"
      autocomplete="off"
    />
    <label class="btn btn-outline-secondary" :for="anyAibId">
      <FontAwesomeIcon icon="globe" class="me-1" />
      {{ t("bulk_buy.cancellation_option_any_registry") }}
    </label>
  </div>
</template>

<script setup lang="ts">
import { CancellationMode } from "@/dashboard/inventory_management/bulk_buy/bulkBuyTypes";
import { useId } from "vue";
import { useI18n } from "vue-i18n";

/** Null until the user picks a mode. */
const mode = defineModel<CancellationMode | null>({ required: true });

const { t } = useI18n();
const groupName = useId();
const agentId = useId();
const anyAibId = useId();
</script>
